import request from '@/utils/request'
import ApiConfig from './ApiConfig'


export function getCode(params) {
    return request.post(ApiConfig.getCode, params);
}

//查询单条菜单数据
export function userRegister(params) {
    return request.post(ApiConfig.userRegister, params);
}

export function getSmsCode(params) {
    const queryString = Object.keys(params)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
        .join('&');
    const url = `${ApiConfig.getSmsCode}?${queryString}`;
    return request.post(url);
}
export function userLogin(params) {
    const queryString = Object.keys(params)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
        .join('&');
    const url = `${ApiConfig.userLogin}?${queryString}`;
    return request.post(url);
}
export function setAPassword(params) {
    return request.post(ApiConfig.setAPassword, params);
}
export function getAtlasList(params) {
    return request.get(ApiConfig.atlasList, { params: params });
}

export function getDescriptionList(params) {
    return request.get(ApiConfig.descriptionList, { params: params });
}


export function getUserAuthorityList(params) {
    return request.get(ApiConfig.userAuthorityList, { params: params });
}




// folderList: serverUrl + "/system/folder/list", // 文件夹列表
export function getFolderList(params) {
    return request.get(ApiConfig.folderList, { params: params });
}
// layerList: serverUrl + "/system/layer/list", // 图层列表
export function getLayerList(params) {
    return request.get(ApiConfig.layerList, { params: params });
}

export function getUserList(params) {
    return request.get(ApiConfig.userList, { params: params });
}
export function getUserApiList(params) {
    return request.get(ApiConfig.userApiList, { params: params });
}

export function getDescriptionInfo(params) {
    return request.get(ApiConfig.getDescriptionInfo, { params: params });
}


export function getUserJurisdiction(params) {
    return request.get(ApiConfig.getUserJurisdiction, { params: params });
}
export function getDescriptionCode(params) {
    return request.get(ApiConfig.getDescriptionCode, { params: params });
}




// addAtlas: serverUrl + "/system/atlas", // 新增地图
export function addAtlas(params) {
    return request.post(ApiConfig.addAtlas, params);
}
// addFolder: serverUrl + "/system/folder", // 新增文件夹
export function addFolder(params) {
    return request.post(ApiConfig.addFolder, params);
}
// addLayer: serverUrl + "/system/layer/add", // 新增图层
export function addLayer(params) {
    return request.post(ApiConfig.addLayer, params);
}

export function addDescription(params) {
    return request.post(ApiConfig.addDescription, params);
}

//addUserAuthority
export function addUserAuthority(params) {
    return request.post(ApiConfig.addUserAuthority, params);
}


// delAtlas: serverUrl + "/system/atlas/ids", // 删除地图
export function delAtlas(params) {
    const queryString = Object.keys(params)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
        .join('&');
    const url = `${ApiConfig.delAtlas}?${queryString}`;
    return request.put(url);
}
// delFolder: serverUrl + "/system/folder/ids", // 删除文件夹
export function delFolder(params) {
    const queryString = Object.keys(params)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
        .join('&');
    const url = `${ApiConfig.delFolder}?${queryString}`;
    return request.put(url);
}

// delLayer: serverUrl + "/system/layer/ids", // 删除图层
export function delLayer(params) {
    const queryString = Object.keys(params)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
        .join('&');
    const url = `${ApiConfig.delLayer}?${queryString}`;
    return request.put(url);
}
export function delDescription(params) {
    const queryString = Object.keys(params)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
        .join('&');
    const url = `${ApiConfig.delDescription}?${queryString}`;
    return request.put(url);
}



export function delUserAuthority(params) {
    // const queryString = Object.keys(params)
    //    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
    //    .join('&');
    // const url = `${ApiConfig.delUserAuthority}?${queryString}`;
    // return request.post(url);


    return request.post(ApiConfig.delUserAuthority, params);
}



export function updateFolder(params) {
    return request.put(ApiConfig.updateFolder, params);
}

export function updateLayer(params) {
    return request.put(ApiConfig.updateLayer, params);
}
export function updateAtlas(params) {
    return request.put(ApiConfig.updateAtlas, params);
}
export function updateDescription(params) {
    return request.put(ApiConfig.updateDescription, params);
}




export function updateUserAuthority(params) {
    return request.put(ApiConfig.updateUserAuthority, params);
}


export function updateUserInfo(params) {
    return request.put(ApiConfig.updateUserInfo, params);
}







export function moveAtlas(params) {
    const queryString = Object.keys(params)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
        .join('&');
    const url = `${ApiConfig.moveAtlas}?${queryString}`;
    return request.post(url);
}


export function copyAtlas(params) {
    const queryString = Object.keys(params)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key]))
        .join('&');
    const url = `${ApiConfig.copyAtlas}?${queryString}`;
    return request.post(url);
}


export function getConfigList(params) {
    return request.get(ApiConfig.configList, { params: params });
}


export function getCodeList(params) {
    return request.get(ApiConfig.codeList, { params: params });
}


export function updateConfig(params) {
    return request.put(ApiConfig.updateConfig, params);
}